/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Referral_Link_CopiedInputs */

const en_referral_link_copied = /** @type {(inputs: Referral_Link_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Referral link copied!`)
};

const es_referral_link_copied = /** @type {(inputs: Referral_Link_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Enlace de referencia copiado!`)
};

const fr_referral_link_copied = /** @type {(inputs: Referral_Link_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lien de parrainage copié !`)
};

const de_referral_link_copied = /** @type {(inputs: Referral_Link_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empfehlungslink kopiert!`)
};

const ja_referral_link_copied = /** @type {(inputs: Referral_Link_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`紹介リンクをコピーしました！`)
};

const zh_referral_link_copied = /** @type {(inputs: Referral_Link_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`推荐链接已复制！`)
};

const ar_referral_link_copied = /** @type {(inputs: Referral_Link_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تم نسخ رابط الإحالة!`)
};

const id_referral_link_copied = /** @type {(inputs: Referral_Link_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tautan referal disalin!`)
};

const it_referral_link_copied = /** @type {(inputs: Referral_Link_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link di invito copiato!`)
};

const ru_referral_link_copied = /** @type {(inputs: Referral_Link_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Реферальная ссылка скопирована!`)
};

const pt_referral_link_copied = /** @type {(inputs: Referral_Link_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link de indicação copiado!`)
};

const ko_referral_link_copied = /** @type {(inputs: Referral_Link_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`추천 링크가 복사되었습니다!`)
};

/**
* | output |
* | --- |
* | "Referral link copied!" |
*
* @param {Referral_Link_CopiedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const referral_link_copied = /** @type {((inputs?: Referral_Link_CopiedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Referral_Link_CopiedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_referral_link_copied(inputs)
	if (locale === "es") return es_referral_link_copied(inputs)
	if (locale === "fr") return fr_referral_link_copied(inputs)
	if (locale === "de") return de_referral_link_copied(inputs)
	if (locale === "ja") return ja_referral_link_copied(inputs)
	if (locale === "zh") return zh_referral_link_copied(inputs)
	if (locale === "ar") return ar_referral_link_copied(inputs)
	if (locale === "id") return id_referral_link_copied(inputs)
	if (locale === "it") return it_referral_link_copied(inputs)
	if (locale === "ru") return ru_referral_link_copied(inputs)
	if (locale === "pt") return pt_referral_link_copied(inputs)
	return ko_referral_link_copied(inputs)
});